export class Color {
  public id: number;
  public name: string;
  public hex: string;
  public uid: number;

  constructor(id: number, name: string, hex: string, uid: number) {
    this.id = id;
    this.name = name;
    this.hex = hex;
    this.uid = uid;
  }
}
